import React, { useState } from "react";
import { HeroBlock } from "./HeroBlock";
import { Tabs } from "./Tabs";
import { useSearch } from "../../hooks";

export const HeroScreen = () => {
  const { query } = useSearch<{ type: "buy" | "sell" }>({ defaultValues: { type: "buy" } });

  const [type, setType] = useState(query.type);

  const isBuyType = type === "buy";

  return (
    <section className="home_section" style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
      <Tabs onChangeTab={setType} type={type} />

      <span
        style={{
          color: "#ffffff",
          fontSize: "50px",
          lineHeight: "115%",
          fontWeight: 900,
          textAlign: "center",
          maxWidth: "780px",
          alignSelf: "center",
          textTransform: "uppercase",
        }}
      >
        {isBuyType ? "Buy Bitcoin with credit Card or Debit Card" : "Sell Bitcoin and top up your card"}
      </span>

      <HeroBlock isBuyType={isBuyType} />
    </section>
  );
};
